import { ViewSchema } from "./types";

// No filter panel on this dashboard (Solution Overview 6.3), so nothing
// here declares a chipLabel or inFilterPanel: no chip bar renders, and if
// a filter panel is added later, chips follow automatically once a field
// declares one.
export const profilesView: ViewSchema = {
  dashboard: "profiles",
  fields: {
    search: {
      param: "q",
      default: "",
      serialise: (value: string) => (value === "" ? null : value),
      deserialise: (raw) => raw,
      session: true,
    },
    tab: {
      param: "tab",
      default: 0,
      serialise: (value: number) => (value === 0 ? null : String(value)),
      deserialise: (raw) => {
        const parsed = Number(raw);
        return [0, 1, 2].includes(parsed) ? parsed : undefined;
      },
    },
    sortBy: {
      param: "sort",
      default: "created_on",
      serialise: (value: string) => (value === "created_on" ? null : value),
      deserialise: (raw) => raw,
    },
    sortDesc: {
      param: "dir",
      default: true,
      serialise: (value: boolean) => (value ? null : "asc"),
      deserialise: (raw) => raw !== "asc",
    },
    pageSize: {
      param: "size",
      default: 10,
      serialise: (value: number) => (value === 10 ? null : String(value)),
      deserialise: (raw) => {
        const parsed = Number(raw);
        return Number.isInteger(parsed) ? parsed : undefined;
      },
      optionsKey: "pageSizes",
      validate: (value, options) => (options as number[]).includes(value as number),
    },
  },
};
